import { render, staticRenderFns } from "./TuketiciHakemHeyetiKarariAlacakForm.vue?vue&type=template&id=29cf36fa"
import script from "./TuketiciHakemHeyetiKarariAlacakForm.vue?vue&type=script&lang=ts"
export * from "./TuketiciHakemHeyetiKarariAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports